import { sumBy } from 'lodash';
import isEqual from 'react-fast-compare';

import { Assignment } from '@gmm/sdk-voodoo/exercises';
import { ExerciseSkill } from '@gmm/sdk-voodoo/shared';
import { KlassAssignmentsIndexByExercisesItem } from '@gmm/sdk/classAssignments';

import { getActiveSkills } from '../utils';

export const TABLE_MAX_HEIGHT = 220;

export const sumSkillInstances = (skills: ExerciseSkill[]): number =>
  sumBy(skills, skill =>
    skill.removed || !skill.instances ? 0 : Number(skill.instances),
  );

export const skillsWithNumberInstances = (
  skills: ExerciseSkill[],
): ExerciseSkill[] => {
  return skills.map(skill => ({
    ...skill,
    instances: Number(skill.instances),
  }));
};

export const shouldShowWarning = (
  { classes, skills }: Assignment,
  values: Assignment,
): boolean =>
  classes > 0 &&
  (sumSkillInstances(skills) !== sumSkillInstances(values.skills) ||
    // map skills to a simpler object to only compare type and instances
    !isEqual(
      getActiveSkills(skills).map(s => ({
        type: s.type,
        instances: s.instances,
      })),
      getActiveSkills(skillsWithNumberInstances(values.skills)).map(s => ({
        type: s.type,
        instances: s.instances,
      })),
    ));

export const shouldShowProTip = ({ skills }: Assignment): boolean =>
  sumSkillInstances(skills) >= 15 || skills.length >= 5;

export const generateUnsavedExamIdentifier = (): string => {
  const max = -1;
  const min = Number.MIN_SAFE_INTEGER;
  const randomNum = Math.floor(Math.random() * (max - min + 1)) + min;

  return String(randomNum);
};

export const getAssignedOrScheduledClassIds = (
  classAssignments: KlassAssignmentsIndexByExercisesItem[],
): string[] => {
  return classAssignments
    .filter(({ assignedAt, releaseDate }) => !!assignedAt || !!releaseDate)
    .map(({ classId }) => classId);
};
